import React, { useState, useEffect, useCallback } from "react";
import { Dropdown } from "react-bootstrap";

export default function SelectVoiceDropDown({
  voices = [],
  answer,
  sound,
  selected,
  audioFinished = false,
  changeAudio,
}) {
  const [open, setOpen] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState(selected);

  const disabled = answer || sound === false || audioFinished;

  /* Sync external selected value */
  useEffect(() => {
    setSelectedVoice(selected);
  }, [selected]);

  const handleToggle = useCallback(
    (nextOpen, event) => {
      if (disabled) return;
      setOpen(nextOpen);
    },
    [disabled]
  );

  const handleSelect = (item) => {
    setSelectedVoice(item.label);
    setOpen(false);
    changeAudio(item);
  };

  return (
    <div style={styles.container}>
      <label style={styles.label}>Voice</label>
    <Dropdown show={open} onToggle={handleToggle} id="playbackbtn">
      <Dropdown.Toggle
        as="span"
        // type="button"
        disabled={disabled}
        style={{
          ...styles.toggle,
          ...(open ? styles.toggleOpen : {}),
          ...(disabled ? styles.disabled : {}),
        }}
        // className="voice-dropdown-toggle"
      >
        <span>{selectedVoice}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu style={styles.menu}>
        {voices
          .filter((v) => v.label !== selectedVoice)
          .map((item, i) => (
            <Dropdown.Item
              key={i}
              style={styles.item}
              onClick={() => handleSelect(item)}
            >
              {item.label}
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  </div>
  );
}

const styles = {
  container: {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  alignItems:"start"
},

label: {
  fontSize: "12px",
  fontWeight: "500",
  color: "#333",

},
  toggle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "6px",
    padding: "9px 12px",
    border: "1px solid #000",
    borderRadius: "25px",
    backgroundColor: "#fff",
    cursor: "pointer",
    userSelect: "none",
    fontSize: "14px",
    minWidth: "80px",
  },

  toggleOpen: {
    boxShadow: "0 4px 12px rgba(0,0,0,.12)",
  },

  menu: {
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 8px 20px rgba(0,0,0,.15)",
    minWidth: "140px",
    marginTop: "6px",
    zIndex: 9999,
  },

  item: {
    padding: "8px 14px",
    fontSize: "14px",
    cursor: "pointer",
  },

  disabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
};
